/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ComunicazioneEmailInvioDTO } from './comunicazione-email-invio-dto';


export interface PagedModelComunicazioneEmailInvioDTO { 
    content?: Array<ComunicazioneEmailInvioDTO>;
    page?: PageMetadata;
}

